var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge display-flex align--center"},[_c('div',{staticClass:"badge__count"},[_c('span',{staticClass:"regular-12"},[_vm._v(_vm._s(_vm.count))])]),_c('social-icon',{staticClass:"badge__icon",attrs:{"type":_vm.channel,"size":16}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }